import { createFileRoute } from "@tanstack/react-router";
import BlogArticle from "@/pages/BlogArticle";
import { articles } from "@/pages/Blog";
import { buildHead, SITE_URL } from "@/lib/seo-head";

export const Route = createFileRoute("/blog/$slug")({
  head: ({ params }) => {
    const article = articles.find((a) => a.slug === params.slug);
    if (!article) {
      return buildHead({
        title: "Artigo não encontrado | OP2P",
        description: "O artigo que você procura não existe ou foi movido.",
        path: `/blog/${params.slug}`,
        noindex: true,
      });
    }
    return buildHead({
      title: article.seoTitle ?? article.title,
      description: article.excerpt,
      path: `/blog/${article.slug}`,
      type: "article",
      image: article.image.startsWith("http") ? article.image : `${SITE_URL}${article.image}`,
    });
  },
  component: BlogArticle,
});
